import { useViewport } from '../../hooks/useViewport';

import PeoplePickerField from './PeoplePickerField';
import type { ClientDealDraft } from './private-event-client-deal';

interface Props {
  draft: ClientDealDraft;
  set: <K extends keyof ClientDealDraft>(key: K, value: ClientDealDraft[K]) => void;
  fieldError: (key: string) => string | undefined;
}

/** The three people pickers: one list of active users, the owner required. */
export default function ClientDealPeople({ draft, set, fieldError }: Props) {
  const { isPhone } = useViewport();
  return (
    <div
      style={{ display: 'grid', gridTemplateColumns: isPhone ? '1fr' : 'repeat(3, 1fr)', gap: 12 }}
    >
      <PeoplePickerField
        label="National coordinator"
        clearable
        value={draft.nationalCoordinatorUserId}
        valueName={draft.nationalCoordinatorName}
        error={fieldError('nationalCoordinatorUserId')}
        onChange={(u) => {
          set('nationalCoordinatorUserId', u?.id ?? '');
          set('nationalCoordinatorName', u?.name ?? '');
        }}
      />
      <PeoplePickerField
        label="Regional coordinator"
        hint="owner"
        required
        clearable={false}
        value={draft.ownerUserId}
        valueName={draft.ownerName}
        error={fieldError('ownerUserId')}
        onChange={(u) => {
          if (!u) return;
          set('ownerUserId', u.id);
          set('ownerName', u.name);
        }}
      />
      <PeoplePickerField
        label="Deal originator"
        clearable
        value={draft.dealOriginatorUserId}
        valueName={draft.dealOriginatorName}
        error={fieldError('dealOriginatorUserId')}
        onChange={(u) => {
          set('dealOriginatorUserId', u?.id ?? '');
          set('dealOriginatorName', u?.name ?? '');
        }}
      />
    </div>
  );
}
